<span *ngFor="let item of config; let i = index">
    <!-- Icona AngularMaterial (default) -->
    <mat-icon *ngIf="!item?.iconType || item?.iconType == 0"
              [ngClass]="{'multi-icon-cell-renderer-hidden': item.hidden}"
              class="multi-icon-cell-renderer"
              title="{{item?.tooltip | translate}} {{item.showAdditionalInfo ? item.additionalInfo : ''}}{{!!propertyValue[i] ? (': ' + propertyValue[i]) : ''}}">{{item?.icon}}</mat-icon>

    <!-- Icona SeSvg -->
    <mat-icon *ngIf="item?.iconType == 1"
              class="multi-icon-cell-renderer svg-icon"
              [ngClass]="{'multi-icon-cell-renderer-hidden': item.hidden}"
              [svgIcon]="item?.icon"
              title="{{item?.tooltip | translate}} {{item.showAdditionalInfo ? item.additionalInfo : ''}}{{!!propertyValue[i] ? (': ' + propertyValue[i]) : ''}}"></mat-icon>

    <!-- Icona SeFont -->
    <mat-icon *ngIf="item?.iconType == 2" fontSet="estensa-icons"
              class="multi-icon-cell-renderer"
              [ngClass]="{'multi-icon-cell-renderer-hidden': item.hidden}"
              [ngStyle]="{'font-size' : item?.iconsize }"
              title="{{item?.tooltip | translate}} {{item.showAdditionalInfo ? item.additionalInfo : ''}}{{propertyValue[i] ? (': ' + propertyValue[i]) : ''}}">{{item?.icon}}</mat-icon>

</span>
